import { CalendarSelection, Day, FrequencyType } from '../../types/calendar.types'
import { convertEpochToDate } from '../utils'

const getSelectedDay = (
  calendarSelection: CalendarSelection,
  availableMonthlyDays: Day[],
  availableWeeklyDays: Day[],
  availableDailyDays: Day[]
): Day | undefined => {
  let availableDays: Day[] = []

  switch (calendarSelection.frequencyType) {
    case FrequencyType.WEEKLY:
      availableDays = availableWeeklyDays
      break
    case FrequencyType.DAILY:
      availableDays = availableDailyDays
      break
    case FrequencyType.MONTHLY:
    default:
      availableDays = availableMonthlyDays
      break
  }

  return availableDays?.find((day) => day.day === calendarSelection.value)
}

export const getWhyNotSIPDate = (
  calendarSelection: CalendarSelection,
  availableMonthlyDays: Day[],
  availableWeeklyDays: Day[],
  availableDailyDays: Day[]
): number | null => {
  const selectedDay = getSelectedDay(calendarSelection, availableMonthlyDays, availableWeeklyDays, availableDailyDays)

  if (selectedDay && selectedDay?.whyNotDate) {
    return selectedDay?.whyNotDate ?? null
  }

  return null
}

export const getNextSIPDate = (
  calendarSelection: CalendarSelection,
  availableMonthlyDays: Day[],
  availableWeeklyDays: Day[],
  availableDailyDays: Day[]
): number | null => {
  const selectedDay = getSelectedDay(calendarSelection, availableMonthlyDays, availableWeeklyDays, availableDailyDays)

  if (selectedDay && selectedDay?.nextSipDate) {
    return selectedDay?.nextSipDate ?? null
  }

  return null
}

const getDaySuffix = (day: number) => {
  if (day >= 11 && day <= 13) return 'th'
  switch (day % 10) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}

export const getFrequencyText = (calendarSelection: CalendarSelection) => {
  switch (calendarSelection.frequencyType) {
    case FrequencyType.WEEKLY:
      const weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
      const weekDayName = calendarSelection?.value ? weekDays[calendarSelection.value - 1] : ''
      return `Every ${weekDayName}`
    case FrequencyType.DAILY:
      return `Every ${calendarSelection?.value} day${calendarSelection?.value && calendarSelection?.value > 1 ? 's' : ''}`
    case FrequencyType.MONTHLY:
    default:
      const daySuffix = getDaySuffix(calendarSelection?.value ?? 0)
      return `On ${calendarSelection?.value}${daySuffix} of every month`
  }
}
